module.exports = __webpack_public_path__ + "img/first_cf_tips_header.9fdbc53e.svg";